<template>
  <el-tooltip
    :disabled="!item.onlyRegistered"
    class="item"
    effect="dark"
    placement="top-start"
  >
    <template slot="content">
      <span class="" v-if="item.onlySubscribed">
        For {{ item.memberships[0].name }} Only
      </span>
      <span class="" v-if="item.onlyRegistered && !item.onlySubscribed">
        For Registered Users Only
      </span>
    </template>
    <div class="relative">
      <span
        class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
        v-if="item.onlySubscribed"
      >
        For Subscribers Only
      </span>
      <span
        class="absolute top-3 left-3 z-index-999 flex gap-1 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
        v-if="item.onlyRegistered && !item.onlySubscribed"
        ><feather-icon icon="UnlockIcon" svgClasses="w-4" />
        Access Caregiver Saathi
      </span>
      <div class="border rounded-xl overflow-hidden cursor-pointer">
        <!-- <img
            v-if="item.hasOwnProperty('fileType') && item.fileType == 'Url'"
            :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
            class="h-52 w-full object-cover"
            />
          <img
            @click="openFile(i)"
            v-else-if="item.hasOwnProperty('fileType') && item.fileType == 'Image'"
            :src="`${$imageURL}/${item.file}`"
            class="h-52 w-full object-cover"
          />
          <img
            @click="openFile(i)"
            v-else-if="item.hasOwnProperty('fileType') && item.fileType == 'Document'"
            src="https://nimbuscluster.blob.core.windows.net/server01/taskmanager/images.png"
            class="h-52 w-full object-cover"
              /> -->

        <img
          v-if="item.hasOwnProperty('bannerImage') && item.bannerImage != ''"
          :src="`${$imageURL}/${item.bannerImage}`"
          class="h-52 w-full object-contain bg-fa cursor-pointer flex"
          @click="openFile(i)"
        />
        <div class="flex justify-between relative" v-else>
          <img
            :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
            alt="Event image"
            class="h-52 w-full object-contain bg-fa cursor-pointer flex"
          />
          <div class="absolute right-5 top-2" v-if="type === 'Upcoming'">
            <!-- v-b-modal.modal-1 -->
            <!-- <img
                @click="setLink(item.url)"
                src="../../../assets/images/share.png"
                alt="ShareIcon"
                class="h-5 w-5 cursor-pointer"
              /> -->
          </div>
        </div>

        <div class="lg:px-4 md:px-4 px-4 py-1">
          <h4
            class="text-dark fsize20 leading-6 mt-3 font-semibold lineclamp-1"
          >
            {{ item.title }}
          </h4>

          <p class="mt-1 fsize14 text-dark font-semibold">
            Date: <span class="font-normal">{{ getDate(item.createdAt) }}</span>
          </p>

          <!-- <div>
              <p
                class="mt-1 fsize14 text-dark font-semibold"
                v-if="item.hasOwnProperty('fileType') && item.fileType == 'Url'"
              >
                <span class="font-normal">{{ item.url }}</span>
                      </p>
                    </div> -->

          <div>
            <el-dialog
              :visible.sync="readMoreVisible"
              width="30%"
              :before-close="handleClose"
            >
              <span class="break-normal">{{ readMoreData }}</span>
            </el-dialog>
            <div class="h-12">
              <p
                class="mt-1 fsize14 text-dark cursor-pointer font-normal lineclamp-2"
              >
                {{ item.description }}
                <!-- <span
                  v-if="item.description.length >= 40"
                  @click="handleReadMore(true, i)"
                  class="text-primary"
                  >read more</span
                > -->
              </p>
            </div>
          </div>

          <div class="flex items-center gap-2 justify-content-center">
            <b-button
              class="mb-2 mt-1 border-2"
              variant="primary"
              @click="handleOpenLink(item.url)"
              >Read More</b-button
            >
          </div>
        </div>
      </div>
      <!-- <div
      v-if="
        Object.keys(user).length == 0 &&
        Object.hasOwn(item, 'memberships') &&
        item.memberships != null &&
        Object.keys(item.memberships).length !== 0
      "
      class="relative"
    >
      <span class="absolute top-3 left-1 z-index-999">
        <img
          class="rounded-full w-6 h-6"
          :src="$imageURL + '/' + item.memberships[0].image"
          :style="{}"
        />
        {{ item.memberships[0].name }}
      </span>
    </div> -->
      <!-- <span class="blog-tooltiptext-ui" v-if="item.onlySubscribed">
        For {{ item.memberships[0].name }} Only
      </span>
      <span
        class="blog-tooltiptext-ui"
        v-if="item.onlyRegistered && !item.onlySubscribed"
      >
        For Registered Users Only
      </span> -->

      <!-- <img
      v-b-modal.modal-1
      @click="
        dialogVisible = true;
        setLink(item.link);
      "
      src="../../../assets/images/share.png"
      alt="ShareIcon"
      class="h-6 w-6 cursor-pointer"
    /> -->
    </div>
  </el-tooltip>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    category: {
      type: String,
      default: "blog",
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      categoryId: "",
      hasError: false,
      copy: "",
      defaultImage:
        this.$imageURL + "/caregiversaathi/default/dummy%20image.jpg",
      shareImage: require("../../../assets/images/share.png"),
    };
  },
  computed: {
    image() {
      return this.item.image
        ? `${this.$imageURL}/${this.item.image}`
        : this.defaultImage;
    },
    url() {
      if (this.item.link.includes("http")) {
        return this.item.link;
      } else {
        return "https://" + this.item.link;
      }
    },
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      categorywisepagesforevent: "categorywisepagesforevent",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
  },
  methods: {
    // handleShare(event) {
    //   // dialogVisible = true;
    //   setLink(item.link);
    //   event.stopPropagation();
    // },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    setLink(link) {
      //    this.copy = link;
      // this.$emit("eventCopy", link);
      // let clickedBlogId = "";
      // if (Object.keys(this.user).length !== 0) {
      //   if (this.type.includes("Featured")) {
      //     this.categorywisepagesforevent.featured.forEach((element) => {
      //       if (element._id === this.item._id) {
      //         if (
      //           element.memberships != null &&
      //           element.memberships.length !== 0
      //         ) {
      //           clickedBlogId = element.memberships[0]._id;
      //         }
      //       }
      //     });
      //   } else if (this.type.includes("Past")) {
      //     this.categorywisepagesforevent.past.forEach((element) => {
      //       // console.log("Past Here");
      //       if (element._id === this.item._id) {
      //         if (
      //           element.memberships != null &&
      //           element.memberships.length !== 0
      //         ) {
      //           clickedBlogId = element.memberships[0]._id;
      //         }
      //       }
      //     });
      //   } else if (this.type.includes("Upcoming")) {
      //     this.categorywisepagesforevent.upcoming.forEach((element) => {
      //       // console.log("Past Here");
      //       if (element._id === this.item._id) {
      //         if (
      //           element.memberships != null &&
      //           element.memberships.length !== 0
      //         ) {
      //           clickedBlogId = element.memberships[0]._id;
      //         }
      //       }
      //     });
      //   }
      // }
      // if (this.item.onlyRegistered) {
      //   if (Object.keys(this.user).length === 0) {
      //     this.$router.push({ name: "signin" });
      //     Swal.fire({
      //       title: "Login",
      //       text: "To access the content, kindly proceed with registration/login",
      //       icon: "warning",
      //       confirmButtonColor: "#830c81",
      //       showConfirmButton: true,
      //     });
      //     return;
      //     //   .then((result) => {
      //     //   if (result.isConfirmed) {
      //     //     this.$router.push({ name: "signin" });
      //     //   }
      //     // });
      //   } else if (this.item.onlySubscribed) {
      //     if (
      //       this.user.membership != null &&
      //       this.user.membership.includes(clickedBlogId)
      //     ) {
      //       // console.log("here");
      //       this.copy = link;
      //       this.$emit("eventCopy", link);
      //       this.$bvModal.show("modal-1");
      //     } else {
      //       Swal.fire({
      //         title: "Upgrade Plan",
      //         text: "Upgrade now for unrestricted access!",
      //         icon: "info",
      //         confirmButtonColor: "#830c81",
      //         confirmButtonText: "Show Plans",
      //         showConfirmButton: true,
      //         showCancelButton: true,
      //       }).then((e) => {
      //         if (e.isConfirmed) {
      //           this.$router.push({
      //             path: "/product-services",
      //             query: { buymembership: true },
      //           });
      //         }
      //       });
      //     }
      //   } else {
      //     // console.log("here 2");
      //     this.copy = link;
      //     this.$emit("eventCopy", link);
      //     this.$bvModal.show("modal-1");
      //   }
      // } else {
      //   // console.log("here 3");
      this.copy = link;
      this.$emit("eventCopy", link);
      this.$bvModal.show("modal-1");
      // }

      // console.log(link);
    },
    async handleOpenLink(URL) {
      console.log(URL, "URLLLLL");
      let link = "";
      // try {
      //   let clickedBlogId = "";
      //   if (Object.keys(this.user).length !== 0) {
      //     if (this.type.includes("Featured")) {
      //       this.categorywisepagesforevent.featured.forEach((element) => {
      //         if (element._id === this.item._id) {
      //           if (
      //             element.memberships != null &&
      //             element.memberships.length !== 0
      //           ) {
      //             clickedBlogId = element.memberships[0]._id;
      //           }
      //         }
      //       });
      //     } else if (this.type.includes("Past")) {
      //       this.categorywisepagesforevent.past.forEach((element) => {
      //         // console.log("Past Here");
      //         if (element._id === this.item._id) {
      //           if (
      //             element.memberships != null &&
      //             element.memberships.length !== 0
      //           ) {
      //             clickedBlogId = element.memberships[0]._id;
      //           }
      //         }
      //       });
      //     } else if (this.type.includes("Upcoming")) {
      //       this.categorywisepagesforevent.upcoming.forEach((element) => {
      //         // console.log("Past Here");
      //         if (element._id === this.item._id) {
      //           if (
      //             element.memberships != null &&
      //             element.memberships.length !== 0
      //           ) {
      //             clickedBlogId = element.memberships[0]._id;
      //           }
      //         }
      //       });
      //     }
      //   }

      //   if (this.item.onlyRegistered) {
      //     if (Object.keys(this.user).length === 0) {
      //       this.$router.push({ name: "signin" });
      //       Swal.fire({
      //         title: "Login",
      //         text: "To access the content, kindly proceed with registration/login",
      //         icon: "warning",
      //         confirmButtonColor: "#830c81",
      //         showConfirmButton: true,
      //       });
      //       return;
      //       // .then((result) => {
      //       //   if (result.isConfirmed) {
      //       //     this.$router.push({ name: "signin" });
      //       //   }
      //       // });
      //     } else if (this.item.onlySubscribed) {
      //       // console.log("here out", this.type.includes("Past"));
      //       // console.log(this.user.membership, clickedBlogId);
      //       if (
      //         this.user.membership != null &&
      //         this.user.membership.includes(clickedBlogId)
      //       ) {
      //         // console.log("here");
      //         if (this.item.link.includes("http")) {
      //           link = this.item.link;
      //         } else {
      //           link = "https://" + this.item.link;
      //         }
      //         window.open(link, "_blank");
      //       } else {
      //         Swal.fire({
      //           title: "Upgrade Plan",
      //           text: "Upgrade now for unrestricted access!",
      //           icon: "info",
      //           confirmButtonColor: "#830c81",
      //           confirmButtonText: "Show Plans",
      //           showConfirmButton: true,
      //           showCancelButton: true,
      //         }).then((e) => {
      //           if (e.isConfirmed) {
      //             this.$router.push({
      //               path: "/product-services",
      //               query: { buymembership: true },
      //             });
      //           }
      //         });
      //       }
      //     } else {
      //       // console.log("here 2");
      //       if (this.item.url.includes("http")) {
      //         link = this.item.url;
      //       } else {
      //         link = "https://" + this.item.url;
      //       }
      //       window.open(link, "_blank");
      //     }
      //   } else {
      //     // console.log("here 3");

      //     if (this.item.url.includes("http")) {
      //       link = this.item.url;
      //     } else {
      //       link = "https://" + this.item.url;
      //     }
      //     window.open(link, "_blank");
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
      if (URL.includes("http")) {
        link = URL;
      } else {
        link = "https://" + URL;
      }
      window.open(link, "_blank");
    },
  },
  async mounted() {
    // if (Object.keys(this.user).length !== 0) {
    //   let getUserPayload = {
    //     userId: this.user._id,
    //   };
    //   const getUser = await this.$store.dispatch(
    //     "auth/getUserByUserId",
    //     getUserPayload
    //   );
    // }
  },
};
</script>

<style>
.bottom-63p {
  bottom: 63%;
}
</style>
